import Vue from 'vue';
import Router from 'vue-router';
import CabinetList from '@/components/cabinetList/CabinetList';
import CabinetDetail from '@/components/cabinetDetail/CabinetDetail';
import CabinetDynamicDetail from '@/components/cabinetDetail/DynamicDetail';
import IpAddress from '@/components/ipAddress/IpAddress';
import BandWidth from '@/components/bandWidth/BandWidth';
import BandWidthDetail from '@/components/bandWidthDetail/BandWidthDetail';
import EquipmentList from '@/components/Equipment/EquipmentList';
import EquipmentDetail from '@/components/Equipment/EquipmentDetail';
import BuyCabinet from '@/components/buyCabinet/BuyCabinet';

// 工单管理 => 提交工单
import SubmitWorkSheet from '@/components/workSheet/SubmitWorkSheet';
import CabinetOutfit from '@/components/workSheet/CabinetOutfit';
// 工单管理 => 我的工单
import MyWorksheet from '@/components/workSheet/MyWorksheet';
// 工单管理 => 我的工单 => 工单详情
import WorksheetDetail from '@/components/workSheet/WorksheetDetail';

// 概览
import OverView from '@/components/resourceOverview/OverView';
import BandwidthTraffic from '@/components/bandwidthTraffic/TrafficList';
import BandwidthTrafficDetail from '@/components/bandwidthTraffic/TrafficDetail';

// 账单
import BillList from "@/components/billList/BillList";
// 巡检报告
import InspectionRegionList from "@/components/inspection/region/RegionList";
import InspectionDeviceList from "@/components/inspection/device/DeviceList";


Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      // 不匹配的路由，跳回首页（当前没有404页）
      path: "*",
      redirect: "/",
      meta: {
        permission: "",
      }
    },
    {
      path: "/",
      name: "Default",
      meta: {
        permission: "",
      },
      component: OverView
    },
    // {
    //     path: '/',
    //     name: 'Default',
    //     component: CabinetList
    // },
    {
      path: "/resourcemanagement/overview",
      name: "overView",
      meta: {
        permission: "",
      },
      component: OverView
    },
    {
      path: "/ipAddress/list",
      name: "IpAddress",
      meta: {
        permission: "resource",
      },
      component: IpAddress
    },
    {
      path: "/bandWidth/list",
      name: "BandWidth",
      meta: {
        permission: "resource",
      },
      component: BandWidth
    },
    {
      path: "/cabinet/list",
      name: "CabinetList",
      meta: {
        permission: "resource",
      },
      component: CabinetList
    },
    {
      path: "/cabinet/detail",
      name: "CabinetDetail",
      meta: {
        permission: "resource",
      },
      component: CabinetDetail
    },
    {
      path: "/cabinet/dynamic",
      name: "CabinetDynamicDetail",
      meta: {
        permission: "resource",
      },
      component: CabinetDynamicDetail
    },
    {
      path: "/equipment/list",
      name: "EquipmentList",
      meta: {
        permission: "resource",
      },
      component: EquipmentList
    },
    {
      path: "/equipment/detail",
      name: "EquipmentDetail",
      meta: {
        permission: "resource",
      },
      component: EquipmentDetail
    },
    {
      path: "/worksheet/init",
      name: "SubmitWorkSheet",
      meta: {
        permission: "ticket",
      },
      component: SubmitWorkSheet
    },
    {
      path: "/worksheet/submit/:id",
      name: "CabinetOutfit",
      meta: {
        permission: "ticket",
      },
      component: CabinetOutfit
    },
    {
      path: "/myworksheet/list",
      name: "MyWorksheet",
      meta: {
        permission: "ticket",
      },
      component: MyWorksheet
    },
    {
      path: "/myworksheet/detail/:id",
      name: "WorksheetDetail",
      meta: {
        permission: "ticket",
      },
      component: WorksheetDetail
    },
    {
      path: "/bandwidth/detail",
      name: "BandWidthDetail",
      meta: {
        permission: "resource",
      },
      component: BandWidthDetail
    },
    {
      path: "/bandwidthtraffic/list",
      name: "BandwidthTraffic",
      meta: {
        permission: "monitor",
      },
      component: BandwidthTraffic
    },
    {
      path: "/bandwidthtraffic/detail/:id",
      name: "BandwidthTrafficDetail",
      meta: {
        permission: "monitor",
      },
      component: BandwidthTrafficDetail
    },
    {
      path: "/worksheet/submit/equipmentMoveIn/:id/:code",
      name: "EquipmentIn",
      meta: {
        permission: "ticket",
      },
      component: () => import("@/components/workSheet/equipmentIn/EquipmentIn")
    },
    {
      path: "/worksheet/submit/equipmentMoveOut/:id/:code",
      name: "EquipmentOut",
      meta: {
        permission: "ticket",
      },
      component: () =>
        import("@/components/workSheet/equipmentOut/EquipmentOut")
    },
    {
      path: "/worksheet/submit/equipmentMove/:id/:code",
      name: "EquipmentMove",
      meta: {
        permission: "ticket",
      },
      component: () =>
        import("@/components/workSheet/equipmentMove/EquipmentMove")
    },
    {
      path: "/generalServer/:id/:code",
      name: "GeneralServices",
      meta: {
        permission: "ticket",
      },
      component: () =>
        import("@/components/workSheet/generalServer/GeneralServices")
    },
    {
      path: "/worksheet/submit/roomEntry/:id",
      name: "RoomEntry",
      meta: {
        permission: "ticket",
      },
      component: () => import("@/components/workSheet/roomEntry/RoomEntry")
    },
    {
      path: "/worksheet/submit/servicesupport/:ticketTypeId/:ticketTemplateId",
      name: "ServiceSupport",
      meta: {
        permission: "ticket",
      },
      component: () =>
        import("@/components/workSheet/serviceSupport/ServiceSupport")
    },
    {
      path: "/worksheet/submit/faultReport/:ticketTemplateId/:ticketTypeId",
      name: "FaultReport",
      meta: {
        permission: "ticket",
      },
      component: () => import("@/components/workSheet/faultReport/FaultReport")
    },
    {
      path: "/worksheet/submit/collectDelivery/:ticketTemplateId/:ticketTypeId",
      name: "collectDelivery",
      meta: {
        permission: "ticket",
      },
      component: () => import("@/components/workSheet/expressDelivery/receive")
    },
    {
      path: "/worksheet/submit/SendDelivery/:ticketTemplateId/:ticketTypeId",
      name: "SendDelivery",
      meta: {
        permission: "ticket",
      },
      component: () => import("@/components/workSheet/expressDelivery/send")
    },
    {
      path: "/alarmrules/list",
      name: "AlarmRulesList",
      meta: {
        permission: "alarm",
      },
      component: () => import("@/components/alarm/rules/RulesList")
    },
    {
      path: "/alarmrules/new",
      name: "AlarmRulesAdd",
      meta: {
        permission: "alarm",
      },
      component: () => import("@/components/alarm/rules/RulesAdd")
    },
    {
      path: "/alarmrules/edit/:id",
      name: "AlarmRulesEdit",
      meta: {
        permission: "alarm",
      },
      component: () => import("@/components/alarm/rules/RulesAdd")
    },
    {
      path: "/alarmrules/detail/:id",
      name: "AlarmRulesDetail",
      meta: {
        permission: "alarm",
      },
      component: () => import("@/components/alarm/rules/RulesDetail")
    },
    {
      path: "/alarmhistory/list",
      name: "AlarmHistoryList",
      meta: {
        permission: "alarm",
      },
      component: () => import("@/components/alarm/history/AlarmHistory")
    },
    {
      path: "/worksheet/submit/cabinetPowerUp/:ticketTypeId/:ticketTemplateId",
      name: "cabinetPowerUp",
      meta: {
        permission: "ticket",
      },
      component: () =>
        import("@/components/workSheet/cabinet-powerUp/cabinetPowerUp")
    },
    {
      path:
        "/worksheet/submit/cabinetReservation/:ticketTypeId/:ticketTemplateId",
      name: "cabinetReservation",
      meta: {
        permission: "ticket",
      },
      component: () =>
        import("@/components/workSheet/cabinet-reservation/cabinetReservation")
    },
    {
      path: "/aidc/create",
      name: "buyCabinet",
      meta: {
        permission: "",
      },
      component: () => import("@/components/buyCabinet/BuyCabinet")
    },
    {
      path: "/worksheet/submit/cabinetPowerOff/:ticketTypeId/:ticketTemplateId",
      name: "cabinetPowerOff",
      meta: {
        permission: "ticket",
      },
      component: () =>
        import("@/components/workSheet/cabinet-powerOff/cabinetPowerOff")
    },
    {
      path:
        "/worksheet/submit/equipmentUnsubscribe/:ticketTypeId/:ticketTemplateId",
      name: "equipmentUnsubscribe",
      meta: {
        permission: "ticket",
      },
      component: () =>
        import(
          "@/components/workSheet/equipment-unsubscribe/equipmentUnsubscribe"
        )
    },
    {
      path: "/worksheet/submit/deviceOpen/:ticketTypeId/:ticketTemplateId",
      name: "deviceOpen",
      meta: {
        permission: "ticket",
      },
      component: () => import("@/components/workSheet/device-open/deviceOpen")
    },
    {
      path: "/bill/list",
      name: "BillList",
      meta: {
        permission: "consumption",
      },
      component: BillList
    },
    {
      path: "/inspectionRegion/list",
      name: "InspectionRegionList",
      meta: {
        permission: "inspection",
      },
      component: InspectionRegionList
    },
    {
      path: "/inspectionDevice/list",
      name: "InspectionDeviceList",
      meta: {
        permission: "inspection",
      },
      component: InspectionDeviceList
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js